import t from "i18next";

function n(n, o) {
  return new Promise(function (e, i) {
    t.init(n, function (n, u) {
      return n ? i(n) : (o(function (t) {
        t.prototype.t = r(t.prototype.tNamespaces || [], u);
      }), e({
        t: u,
        i18next: t
      }));
    });
  });
}

var o = t,
    r = function r(t, n) {
  return void 0 === t && (t = []), function (o, r) {
    return n(o, {
      ns: [].concat(t),
      opts: r
    });
  };
};

export { n as boot, o as i18n };